import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/variance-of-visits.png'

const VarianceOfVisits = dynamic(() => import('src/components/insights/location-visits/variance-of-visits'), {
  ssr: false,
})

export const VarianceOfVisitsWidget: InsightBuilderWidget = {
  id: 'variance-of-visits',
  name: 'Variance Of Visits',
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  component: VarianceOfVisits,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
